// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Product Cache Service
// Thin wrapper around the offline queue's IndexedDB product cache.
// ---------------------------------------------------------------------------

import { offlineQueue } from '@/services/offline-queue';
import type { Product } from '@/lib/types';

/**
 * Cache products into IndexedDB for offline fallback.
 * Delegates to the offline queue's product_cache store.
 */
export async function cacheProducts(products: Product[]): Promise<void> {
  await offlineQueue.cacheProducts(products);
}

/**
 * Retrieve cached products from IndexedDB.
 * Returns an empty array if no cache exists.
 */
export async function getCachedProducts(): Promise<Product[]> {
  return offlineQueue.getCachedProducts();
}
